import { render, staticRenderFns } from "./EditBulkClaimAmountConfirmationDialog.vue?vue&type=template&id=a541bfbc&lang=pug&"
import script from "./EditBulkClaimAmountConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./EditBulkClaimAmountConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports